module.exports = __webpack_public_path__ + "static/media/monopoly card - 2.2e7ee667.PNG";